import ResponsiveImage from "../../../../shared/components/elements/ResponsiveImage";
import type { ImageConfig } from "../../blockTypes";

interface ImageBlockProps {
    config?: ImageConfig;
}

const ImageBlock = ({ config }: ImageBlockProps) => {
    if (!config?.src) return null;

    return (
        <div className="w-full flex justify-center">
            {/* Lesson images live in the private bucket */}
            <ResponsiveImage
                isPublic={false}
                src={config.src}
                alt={config.alt ?? ""}
                className="max-w-full h-auto rounded-xl object-contain"
            />
        </div>
    );
};

export default ImageBlock;